import { Page, Text, View, Document, StyleSheet, Font } from "@react-pdf/renderer";
import NanumGothicR from './Malgun-Gothic-Bold_29380.ttf';
import NanumGothic from './NanumGothicCoding-Regular.ttf';

  Font.register({
    family : 'NanumGothicR',
    src : NanumGothicR,
  })

  Font.register({
    family : 'NanumGothic',
    src : NanumGothic,
  })
  
  
const styles = StyleSheet.create({
  body: {
    paddingTop: 35,
    paddingBottom: 65,
    paddingHorizontal: 35,
    fontFamily : 'NanumGothicR',
    display: 'flex',
    flexDirection: 'column',
  },
  infoText: {
    margin: 5,
    fontSize: 9,
    textAlign: "justify",
    fontFamily: "NanumGothicR",
  },
  infoText2: {
    fontSize: 9,
    textAlign: "justify",
    fontFamily: "NanumGothicR",

  },
  pageNumber: {
    position: "absolute",
    fontSize: 9,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },
  listHeader: {
    borderTop: '1px solid black',
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    width: '100%',
    minHeight: 12,
    display: 'flex',
    flexDirection: 'row',
    backgroundColor: '#F8F8FF'
  },
  listContItm1: {
    borderRight: '1px solid black',
    flex: 1,
    minHeight: 12,
    display: 'flex',
    justifyContent: 'center',
  },
  listContItm2: {
    borderRight: '1px solid black',
    flex: 3,
    minHeight: 12,
    display: 'flex',
    justifyContent: 'center',
  },
  listContItm3: {
    borderRight: '1px solid black',
    flex: 0.5,
    minHeight: 12,
    display: 'flex',
    justifyContent: 'center',
  },
  listContItm4: {
    borderRight: '1px solid black',
    flex: 1.5,
    minHeight: 12,
    display: 'flex',
    justifyContent: 'center',
  },
  listText: {
    fontSize: 9,
    marginLeft: 5,
    fontFamily: "NanumGothicR",

  },
  listText1: {
    fontSize: 9,
    marginLeft: 5,
    textAlign: 'center',
    fontFamily: "NanumGothicR",

  },
  listText2: {
    fontSize: 18,
    marginLeft: 5,
    fontFamily: "NanumGothic",
    fontWeight: 'bold'
  },
  listMain: {
    borderLeft: '1px solid black',
    borderBottom: '1px solid black',
    width: '100%',
    minHeight: 12,
    display: 'flex',
    flexDirection: 'row'
  },

  infoTextnum: {
    fontSize: 9,
    textAlign: "center",
    fontFamily: "NanumGothicR",

  },
  circle: {
    width: 11,
    height: 11, 
    border: '1px solid black',
    borderRadius: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginLeft: 5
  },
  infoBx: {
    borderTop: '1px solid black', 
    borderLeft: '1px solid black', 
    minHeight: 12,
    display: 'flex',
    flexDirection: 'row'
  },
  infoBx2: {
    borderTop: '1px solid black', 
    borderLeft: '1px solid black', 
    height: 24,
    display: 'flex',
    flexDirection: 'row'
  },
  infoItmBx:{
    borderRight: '1px solid black', 
    flex: 1,
    display: 'flex',
    justifyContent: 'center'
  }
});

const OrderPringPDF = ({data, picList}) => {
  return (
    <Document>
      {data.map((item, idx) => {
        let qtySum = item['cartList'].reduce((result, itm) => result + itm['ct_qty'], 0)
        let priceSume = item['cartList'].reduce((result, itm) => result + (itm['ct_qty'] * itm['ct_price']), item['od_send_cost'])

        return (
        <Page
          key={idx}
          size='A4'
          style={styles.body}
        >

          <View style={styles.infoBx}>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>주문일</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['od_time']}</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>희망배송일</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['od_hope_date']}</Text>
            </View>
          </View>
          <View style={styles.infoBx}>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['mb_region']}</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['mb_storename']}</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['mb_name']}</Text>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['mb_hp']}</Text>
            </View>
          </View>
          <View style={styles.infoBx2}>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>주문목록</Text>
            </View>
            <View style={styles.infoItmBx}>
                <Text style={styles.listText2}>{item['od_num']}</Text>
            </View>
            <View style={styles.infoItmBx}>
            </View>
            <View style={styles.infoItmBx}>
              <Text style={styles.listText}>{item['od_receipt_point'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} 포인트</Text>
            </View>
          </View>


          <View style={styles.listHeader}>
            <View style={styles.listContItm2}>
              <Text style={styles.listText}>
                상품명
              </Text>
            </View>
            <View style={styles.listContItm3}>
              <Text style={styles.listText1}>
                체크
              </Text>
            </View>
            <View style={styles.listContItm1}>
              <Text style={styles.listText1}>
                수량
              </Text>
            </View>
            <View style={styles.listContItm1}>
              <Text style={styles.listText1}>
                단가
              </Text>
            </View>
            <View style={styles.listContItm4}>
              <Text style={styles.listText1}>
                공급가
              </Text>
            </View>
          </View>

          {item['cartList'].map((cartItm, index) => {
            let price = cartItm['ct_qty'] * cartItm['ct_price']

            return (<View style={styles.listMain} key={index}>
              <View style={styles.listContItm2}>
                <Text style={styles.listText}>
                  {cartItm['it_name']}
                </Text>
              </View>
              <View style={styles.listContItm3}>
              </View>
              <View style={styles.listContItm1}>
                <Text style={styles.listText1}>
                  {cartItm['ct_qty']}
                </Text>
              </View>
              <View style={styles.listContItm1}>
                <Text style={styles.listText1}>
                  {(price / cartItm['ct_qty']).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Text>
              </View>
              <View style={styles.listContItm4}>
                <Text style={styles.listText1}>
                  {price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                </Text>
              </View>
            </View>);

          })}


          <View style={styles.listMain}>
            <View style={styles.listContItm2}>
              <Text style={styles.listText}>
                배송비
              </Text>
            </View>
            <View style={styles.listContItm3}>
            </View>
            <View style={styles.listContItm1}>
            </View>
            <View style={styles.listContItm1}>
            </View>
            <View style={styles.listContItm4}>
              <Text style={styles.listText1}>
                {item['od_send_cost'].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Text>
            </View>
          </View>
          <View style={styles.listMain}>
            <View style={styles.listContItm2}>
              <Text style={styles.listText}>
                합계
              </Text>
            </View>
            <View style={styles.listContItm3}>
            </View>
            <View style={styles.listContItm1}>
              <Text style={styles.listText1}>
                {qtySum}
              </Text>
            </View>
            <View style={styles.listContItm1}>
            </View>
            <View style={styles.listContItm4}>
              <Text style={styles.listText1}>
                {priceSume.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
              </Text>
            </View>
          </View>

          <Text style={styles.infoText2}>
            * 비고: 
          </Text>
          <View
            style={{
              width: '100%',
            }}
          >
            {item['od_memo'].map((itm, idx) => {
              if(itm.length > 0) return (
              <Text
                key={idx} 
                style={{
                  fontSize: 9,
                  textAlign: "justify",
                  fontFamily: "NanumGothicR",
              
                }}
              >
                {itm}
              </Text>
              )
              return (
              <Text
                key={idx} 
                style={{
                  fontSize: 9,
                  textAlign: "justify",
                  fontFamily: "NanumGothicR",
              
                }}
              >  </Text>
              )
            })}
          </View>



          <Text
            style={styles.pageNumber}
            render={({ pageNumber, totalPages }) =>
              `${pageNumber} / ${totalPages}`
            }
          />
        </Page>
        )
      })}
      
    </Document>
  )
}

export default OrderPringPDF
